module.exports = __webpack_public_path__ + "static/bg-ff89a03c7eb35aa3c740146ec537c5e8.png";